import GoogleMapsApi from './google_maps_api'

export default class GoogleMap {
  constructor ($map, $checkbox) {
    this.$map = $map
    this.companyName = this.$map.data('company')
    this.showInfo = !!this.companyName
    this.query = this.$map.data('query')
    this.$checkbox = $checkbox
    this.initialized = false
    this.addEventHandlers()
    if (this.$checkbox.prop('checked')) {
      this.initialize()
    }
    this.markers = []
    this.infowindows = []
  }

  addEventHandlers () {
    this.$checkbox.click(() => this.initialize())
  }

  initialize () {
    if (!this.initialized) {
      this.initMap()
      this.initialized = true
    }
  }

  initMap () {
    const map = new google.maps.Map(this.$map.get(0), {
      zoom: 14
    })

    let locations = typeof this.query === 'string' ? [this.query] : this.query
    let bounds = new google.maps.LatLngBounds()

    const geocoder = new google.maps.Geocoder()

    locations.forEach(location => {
      geocoder.geocode({ 'address': location }, (results, status) => {
        if (status === 'OK') {
          const latLngPosition = results[0].geometry.location
          const infowindow = new google.maps.InfoWindow({
            content: '<p class="google-maps__js-infotext"><b class="google-maps__js-infotext--bold">' +
              this.companyName + '</b><br>' + location + '</p>'
          })
          let marker = new google.maps.Marker({
            map: map,
            position: latLngPosition
          })

          this.markers.push(marker)
          this.infowindows.push(infowindow)

          if (locations.length > 1) {
            bounds.extend(latLngPosition)
            map.fitBounds(bounds)
            map.panToBounds(bounds)
            map.fitBounds(bounds)
            map.panToBounds(bounds)
          } else {
            map.setCenter(latLngPosition)
          }

          if (this.showInfo) {
            marker.addListener('click', function () {
              infowindow.open(map, marker)
            })
          }
        } else {
          console.log('Geocode was not successful for the following reason: ' + status)
        }
      })
    })

    this.$map.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
      google.maps.event.trigger(map, 'resize')

      if (this.showInfo && locations.length === 1) {
        this.infowindows[0].open(map, this.markers[0])
      }
    })
  }
}

let gmapApi

export const bind = ($context = document) => {
  if (!gmapApi) {
    gmapApi = new GoogleMapsApi()
  }
  gmapApi.load().then(() => {
    $('.js-google-map', $context).each((index, Element) => {
      new GoogleMap($(Element), $('.js-google-map-checkbox', $context))
    })
  })
}

if ($('.js-google-map').length > 0) {
  bind()
}
